<h3>{{ header }}</h3>
<div class="form-well">
    <generator-form [type]="type"></generator-form>
</div>
